import React from 'react'

import {
  Container,
} from './Common'

import { CruiseItem } from 'tripPlanner/types/tripItem'
import {
  isCruiseV2,
  isCustomItem,
} from 'tripPlanner/utils'
import CruiseV1Card from './CruiseV1Card'
import CruiseV2Card from './CruiseV2Card'
import CustomCruise from './CustomCruise'

interface Props {
  item: CruiseItem
}

const CruiseSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }, ref) => {
    const isCruiseV2Item = isCruiseV2(item)

    return (
      <Container ref={ref}>
        {isCustomItem(item) && <CustomCruise item={item} />}
        {item.sourceType === 'LE_Cruise' && isCruiseV2Item && (
          <CruiseV2Card item={item} />
        )}
        {item.sourceType === 'LE_Cruise' && !isCruiseV2Item && (
          <CruiseV1Card item={item} />
        )}
      </Container>
    )
  },
)

export default CruiseSummaryCard
